export { RCPFunctionType, RCPMessage, RCPMessageType } from "@zwave-js/serial";
export type {
	RCPMessageOptions,
	RCPResponsePredicate,
	RCPResponseRole,
} from "@zwave-js/serial";
export type { GetFirmwareInfoResponseOptions } from "@zwave-js/serial/rcp";
export {
	GetFirmwareInfoRequest,
	GetFirmwareInfoResponse,
} from "@zwave-js/serial/rcp";
export type { RCPLogContext } from "./lib/log/RCP.js";
export type {
	PHYLayer,
	TransmitBeamOptions,
	TransmitOptions,
	TransmitResult,
} from "./lib/rcp/PHYLayer.js";
export { ProtocolController } from "./lib/rcp/ProtocolController.js";
export type {
	PartialRCPHostOptions,
	RCPHostEventCallbacks,
	RCPHostEvents,
	RCPHostOptions,
} from "./lib/rcp/RCPHost.js";
export { RCPHost } from "./lib/rcp/RCPHost.js";
export type {
	MACDestinationWakeup,
	MACTransmitAckOptions,
	MACTransmitDestination,
	MACTransmitOptions,
	MACTransmitReport,
} from "./lib/rcp/_Types.js";
export { MACTransmitKind, MACTransmitResult } from "./lib/rcp/_Types.js";
